/**
 * Barefoot-print silhouette (heel + arch + ball + 5 toes), split so we
 * can render one foot at a time for the Million Mile ghost-walker.
 * Rendered with `fill="currentColor"` so the parent's colour/shadow
 * cascade in. RIGHT foot drawn natively; LEFT foot mirrors via
 * `scaleX(-1)`.
 *
 * viewBox 24×36 (aspect 2:3) — CSS `height: --size * 1.5`.
 */
export default function SingleFoot({ side = "L", className = "", style = {} }) {
  const RightFoot = (
    <g>
      {/* Main foot body — one closed path: ball → arch → heel */}
      <path d="M 12 4.5
               C 6.5 4.5, 4 7.5, 4 12
               C 4 15.5, 5 18, 7 20.5
               C 8.5 23, 7 26, 7 28.5
               C 7 31, 9 32.5, 12 32.5
               C 15 32.5, 17 31, 17 28.5
               C 17 26, 15.5 23, 17 20.5
               C 19 18, 20 15.5, 20 12
               C 20 7.5, 17.5 4.5, 12 4.5
               Z" />
      {/* 5 toes — sized big → small from big toe (inside) to pinky */}
      <ellipse cx="5.5"  cy="3"   rx="2.2" ry="2.4" />
      <ellipse cx="9"    cy="1.4" rx="1.9" ry="2.1" />
      <ellipse cx="12"   cy="1.1" rx="1.7" ry="1.9" />
      <ellipse cx="14.8" cy="1.6" rx="1.5" ry="1.7" />
      <ellipse cx="17.2" cy="2.5" rx="1.3" ry="1.5" />
    </g>
  );
  return (
    <svg
      viewBox="0 0 24 36"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {side === "L" ? (
        <g transform="translate(24 0) scale(-1 1)">{RightFoot}</g>
      ) : (
        RightFoot
      )}
    </svg>
  );
}
